export const CHARTS_DEV_SERVER_PORT = "5174";
export const LOCAL_API_BASE_URL = "http://127.0.0.1:5100";
export const LOCAL_HOST_NAMES = new Set(["127.0.0.1", "localhost"]);
export const MILLISECONDS_PER_DAY = 86_400_000;
export const MILLISECONDS_PER_WEEK = MILLISECONDS_PER_DAY * 7;
export const DEFAULT_API_ERROR_MESSAGE = "Nepodařilo se načíst data.";
